import { userActionTypes } from './user.types';

const INITIAL_STATE = {
    currentUser: {},
    users: [],
    // O recorte com que `users` foi carregado pela última vez.
    //
    // Existe para os thunks que recarregam a lista sozinhos (mexer no status,
    // editar, criar) saberem COM QUE recorte recarregar. Antes eles forçavam
    // `includeInactive: true`, que é o que a tela de Operadores quer e
    // nenhuma outra: bastava alguém mexer no status de um usuário para os
    // desativados entrarem na lista de TODAS as telas que leem `users`.
    usersQuery: {},
    authError: null,
    updateSuccess: false,
    indicatorUsers: [],
    welcomeMsg: '',
    closingMsg: '',
    permissions: [],
    token: '',
    userStatus: {},
    tranferUser: {},
    showSessionExpiredModal: false
};

const userReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case userActionTypes.SET_CURRENT_USER:
            return {
                ...state,
                currentUser: action.payload
            };

        case userActionTypes.SET_USERS:
            return {
                ...state,
                users: Array.isArray(action.payload?.users ?? action.payload)
                    ? (action.payload?.users ?? action.payload)
                    : [],
                // Só muda quando o recorte vem junto. Assim um `setUsers`
                // antigo, que manda só o array, não apaga o recorte vigente.
                usersQuery: action.payload?.query ?? state.usersQuery
            };

        case userActionTypes.LOG_OUT:
            return {
                ...state,
                currentUser: null,
                users: null,
                permissions: [],
                token: '',
            };

        case userActionTypes.SET_AUTH_ERROR:
            return {
                ...state,
                authError: action.payload
            };

        case userActionTypes.SET_UPDATE_SUCCESS:
            return {
                ...state,
                updateSuccess: action.payload
            };

        case userActionTypes.SET_INDICATOR_USERS:
            return {
                ...state,
                indicatorUsers: action.payload
            };

        case userActionTypes.SET_WELCOME_MSG:
            return {
                ...state,
                welcomeMsg: action.payload
            };

        case userActionTypes.SET_CLOSING_MSG:
            return {
                ...state,
                closingMsg: action.payload
            };

        case userActionTypes.SET_PERMISSIONS:
            return {
                ...state,
                permissions: action.payload
            };

        case userActionTypes.SET_TOKEN:
            return {
                ...state,
                token: action.payload
            };

        case userActionTypes.SET_USER_STATUS:
            return {
                ...state,
                userStatus: action.payload
            };

        case userActionTypes.SET_TRANSFER_USER:
            return {
                ...state,
                tranferUser: action.payload
            };

        case userActionTypes.SHOW_SESSION_EXPIRED_MODAL:
            return {
                ...state,
                showSessionExpiredModal: true
            };

        case userActionTypes.HIDE_SESSION_EXPIRED_MODAL:
            return {
                ...state,
                showSessionExpiredModal: false
            };

        default:
            return state;
    }
};

export default userReducer;